import { render, staticRenderFns } from "./PDFJSViewer.vue?vue&type=template&id=cacf4e5c&scoped=true"
import script from "./PDFJSViewer.vue?vue&type=script&lang=js"
export * from "./PDFJSViewer.vue?vue&type=script&lang=js"
import style0 from "./PDFJSViewer.vue?vue&type=style&index=0&id=cacf4e5c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "cacf4e5c",
  null
  
)

export default component.exports